// ---------------------------------------------------------------------------
// Prezio Onboard Widget — FooterActions
// ---------------------------------------------------------------------------
// Fixed bottom bar with primary + optional secondary action buttons.
// Glass blur background. Respects safe-area-inset-bottom.
// ---------------------------------------------------------------------------

import styles from './FooterActions.module.css';

interface FooterActionsProps {
  primaryLabel: string;
  onPrimary: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  secondaryLabel?: string;
  onSecondary?: () => void;
}

export function FooterActions({
  primaryLabel,
  onPrimary,
  isLoading = false,
  disabled = false,
  secondaryLabel,
  onSecondary,
}: FooterActionsProps) {
  return (
    <footer className={styles['footer']}>
      <button
        type="button"
        className={styles['primary']}
        onClick={onPrimary}
        disabled={disabled || isLoading}
        aria-busy={isLoading}
      >
        {isLoading && <span className={styles['spinner']} aria-hidden="true" />}
        {primaryLabel}
      </button>

      {secondaryLabel && onSecondary && (
        <button
          type="button"
          className={styles['secondary']}
          onClick={onSecondary}
          disabled={isLoading}
        >
          {secondaryLabel}
        </button>
      )}
    </footer>
  );
}
